import { useEffect, useState } from "react";

export { FuzzyInput };
type Props = {
  initialValue: string;
  update: (result: string) => void;
};
const FuzzyInput = (props: Props) => {
  const [value, setValue] = useState<string>(props.initialValue);

  useEffect(() => {
    if (value !== props.initialValue) {
      setValue(props.initialValue);
    }
  }, [props.initialValue]);

  return (
    <input
      type={"text"}
      className={"monospace"}
      // disabled={loading}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value;
        setValue(newValue);
        if (newValue === "") {
          props.update("");
        }
      }}
      onBlur={() => {
        if (value !== props.initialValue) {
          props.update(value);
        }
      }}
    />
  );
};
